export const list = [
  { name: "Home", path: "/" },
  { name: "O nas", path: "/onas" },
  { name: "Oferta", path: "/oferta" },
  { name: "Cennik", path: "/cennik" },
  { name: "Zamówienia", path: "/zamowienia" },
  //{ name: "Praca", path: "/praca" },
  { name: "Kontakt", path: "/kontakt" },
]
